import type { EntityValidationRules } from "../services/validationService";
import type DistributorType from "./distributorType";
import Optionable from "../utils/optionable";
import type DistributorStatus from "./distributorStatus";
import type CreditExposureNotificationStatus from "./creditExposureNotificationStatus";

@Optionable((distributor: Distributor) => ({ id: distributor.id, label: distributor.name }))
export default class Distributor {
  id: string;
  name: string;
  shortName: string;
  type: DistributorType;
  status: DistributorStatus;
  creditExposureNotificationStatus: CreditExposureNotificationStatus;
  creditExposureWarningPercentage: number = 20;
  usedExposurePercentage: number;
  dueDays: number;
  safeExposure: number;
  email: string;
}

export const DistributorValidationRules: EntityValidationRules<Distributor> = {
  name: {
    required: true,
    isLength: {
      max: 255,
    },
  },
  shortName: {
    required: true,
    isLength: {
      max: 20,
    },
  },
  type: {
    required: true,
  },
  status: { required: true },
  dueDays: {
    required: true,
    range: {
      min: 1,
    },
  },
  safeExposure: {
    required: true,
    range: {
      min: 0,
    },
  },
  creditExposureWarningPercentage: {
    required: true,
    range: {
      min: 0,
      max: 100,
    },
    isInteger: true,
  },
  email: {
    required: true,
    isEmail: { required: true },
  },
};
